import { useState, useEffect } from 'react';
import { supabase } from '@/lib/supabase';

function formatDateTime(dt: string): string {
  return new Date(dt).toLocaleString('de-DE', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' });
}

export function AdminProtokollePage() {
  const [logs, setLogs] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(0);
  const pageSize = 50;

  useEffect(() => { loadLogs(); }, [page]);

  async function loadLogs() {
    const { data } = await supabase
      .from('audit_log')
      .select('*')
      .order('timestamp', { ascending: false })
      .range(page * pageSize, (page + 1) * pageSize - 1);
    setLogs(data || []);
    setLoading(false);
  }

  if (loading) return <div className="container-content py-12"><p className="text-text-secondary">Laden...</p></div>;

  return (
    <div className="container-content py-12">
      <h1 className="text-2xl font-serif mb-6">Audit-Protokolle</h1>

      <div className="overflow-x-auto">
        <table className="min-w-full">
          <thead>
            <tr><th>Zeit</th><th>Aktion</th><th>Entität</th><th>User</th><th>IP</th><th>Details</th></tr>
          </thead>
          <tbody>
            {logs.map((log) => (
              <tr key={log.id}>
                <td className="text-sm font-mono">{formatDateTime(log.timestamp)}</td>
                <td><span className="font-mono text-sm">{log.aktion}</span></td>
                <td className="font-mono text-sm">{log.entitaet_typ}</td>
                <td className="text-sm">{log.profile_id?.substring(0, 8)}</td>
                <td className="font-mono text-xs">{log.ip}</td>
                <td className="text-xs max-w-xs truncate">
                  {log.neue_werte ? JSON.stringify(log.neue_werte).substring(0, 80) : ''}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {logs.length === 0 && <p className="text-text-secondary text-sm mt-4">Keine Protokolle vorhanden.</p>}

      <div className="flex gap-3 mt-6">
        <button onClick={() => setPage((p) => Math.max(0, p - 1))} disabled={page === 0} className="btn-secondary">
          Vorherige
        </button>
        <button onClick={() => setPage((p) => p + 1)} disabled={logs.length < pageSize} className="btn-secondary">
          Nächste
        </button>
      </div>
    </div>
  );
}
